export interface ILocation {
  id: string
  city: string
  stateCode: string
}

export interface IUser {
  id: string
  firstName: string
  lastName: string
}

export interface ILaneManagerAssignment {
  id: string
  createdAt: string
  updatedAt: string
  user: IUser
  updatedBy: IUser
}

export enum EQUIPMENT_TYPE_KEY {
  OPEN_DECK = 'open_deck',
  DRY_VAN = 'dry_van',
  REEFER = 'reefer',
  SPECIALIZED = 'specialized',
}

export enum EQUIPMENT_TYPE_NAME {
  OPEN_DECK = 'Open Deck',
  DRY_VAN = 'Dry Van',
  REEFER = 'Reefer',
  SPECIALIZED = 'Specialized',
}

interface IEquipmentId {
  id: string
  key: EQUIPMENT_TYPE_KEY
  name: EQUIPMENT_TYPE_NAME
}

export interface ITransfixLaneResponse extends ILaneManagerAssignment {
  transfixLane: ITransfixLane
}

export interface ITransfixLane {
  id: string
  laneKey: string
  createdAt: string
  pickupDatMarket: ILocation
  deliveryDatMarket: ILocation
  equipment: IEquipmentId
  laneManagerAssignment?: ILaneManagerAssignment
}

export interface ITransfixById {
  [key: string]: ITransfixLaneResponse | undefined
}

export interface ITransfixLaneState {
  recentLaneId: string
  dataById?: ITransfixById
  loading: boolean
  error: string
}
